export const AI_SCOPE_ALL_CODE = 'page:ai-assistant:data-scope:all';
export const AI_SCOPE_DEPARTMENT_CODE =
  'page:ai-assistant:data-scope:department';
/** 部门查询工具的权限码（与后端 AI_TOOL_CODE_PREFIX + tool 名一致） */
export const AI_TOOL_LIST_DEPARTMENTS_CODE = 'page:ai-assistant:tool:list_departments';

/** 仅本人范围的文案，判定部门功能可用性时用 */
export const AI_SCOPE_SELF_LABEL = '仅本人';

/**
 * 推导当前用户的 AI 数据范围文案，与后端 AiDataScopeService 同规则：
 * superadmin / 全公司码 → 全公司；部门码且有部门 → 本部门及子部门（无部门降级仅本人）；
 * 其余（含未配任何范围码）→ 仅本人。
 * 纯展示用途，不作为任何控制依据（真实边界在后端）。
 */
export const deriveAiScopeLabel = (params: {
  isSuperAdmin?: boolean;
  // NAD 生成的 Long 类型可能是 string 或 number
  departmentId?: string | number | null;
  hasPermission: (code: string) => boolean;
}): string => {
  const { isSuperAdmin, departmentId, hasPermission } = params;
  if (isSuperAdmin || hasPermission(AI_SCOPE_ALL_CODE)) {
    return '全公司';
  }
  if (departmentId != null && hasPermission(AI_SCOPE_DEPARTMENT_CODE)) {
    return '本部门及子部门';
  }
  return AI_SCOPE_SELF_LABEL;
};

/**
 * 是否对当前用户开放部门提及（~ 触发）与部门查询。
 * 与后端一致：要有部门工具权限码，且数据范围不是「仅本人」——
 * 部门功能面向管理层，业务员即使被误勾了权限码也不给。
 */
export const canUseAiDepartment = (params: {
  isSuperAdmin?: boolean;
  departmentId?: string | number | null;
  hasPermission: (code: string) => boolean;
}): boolean => {
  if (!params.hasPermission(AI_TOOL_LIST_DEPARTMENTS_CODE)) {
    return false;
  }
  return deriveAiScopeLabel(params) !== AI_SCOPE_SELF_LABEL;
};
